import { render, staticRenderFns } from "./Ribbon.vue?vue&type=template&id=30b4a47a&scoped=true&"
import script from "./Ribbon.vue?vue&type=script&lang=js&"
export * from "./Ribbon.vue?vue&type=script&lang=js&"
import style0 from "./Ribbon.vue?vue&type=style&index=0&id=30b4a47a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b4a47a",
  null
  
)

export default component.exports